export const systemUserIdStart = 10000;
export const systemBusinessIdStart = 100;